export const METERS_PER_DEGREE_LAT = 111320;

export type LatLng = { lat: number; lng: number };

// approximate planar metres between nearby points - fine for "same street"
// checks, not for long distances
export const approxMetersBetween = (a: LatLng, b: LatLng): number => {
  const dLat = (a.lat - b.lat) * METERS_PER_DEGREE_LAT;
  const dLng =
    (a.lng - b.lng) *
    METERS_PER_DEGREE_LAT *
    Math.cos((((a.lat + b.lat) / 2) * Math.PI) / 180);
  return Math.sqrt(dLat * dLat + dLng * dLng);
};
